import React, { Component } from "react";
import { gql, graphql } from "react-apollo";
import { Link } from "react-router-dom";
import naturalCompare from "natural-compare";
import _ from "lodash";

import {
  Table,
  Grid,
  Notifications,
  Breadcrumbs,
  Loading
} from "components/UI";

class AlertList extends Component {
  render() {
    const { error, loading, buildings } = this.props.data;

    if (error) return <Notifications.Error message={error.message} />;

    const buildingsWithAlerts = loading
      ? []
      : _.filter(buildings, building => building.alertCount > 0);

    const breadcrumbs = [{ name: "Alerts", to: `/alerts` }];

    const columns = [
      {
        Header: "Building",
        id: "name",
        accessor: item => ({ id: item.id, name: item.name }),
        Cell: ({ value }) => (
          <Link to={`/alerts/${value.id}`}>{value.name}</Link>
        ),
        sortMethod: (a, b) => naturalCompare(a.name, b.name)
      },
      {
        Header: "Organization",
        accessor: "organization.name"
      },
      {
        Header: "Alert Count",
        accessor: "alertCount"
      }
    ];

    return (
      <Grid>
        <Grid.Row>
          <Breadcrumbs items={breadcrumbs} />
        </Grid.Row>
        <Grid.Row>
          {loading ? (
            <Loading />
          ) : (
            <Table data={buildingsWithAlerts} columns={columns} />
          )}
        </Grid.Row>
      </Grid>
    );
  }
}

export default graphql(
  gql`
    query AlertListQuery {
      buildings {
        id
        name
        organization {
          id
          name
        }
        alertCount
      }
    }
  `,
  {
    options: { notifyOnNetworkStatusChange: true }
  }
)(AlertList);



// WEBPACK FOOTER //
// ./src/components/Alert/AlertList.jsx